/* ============================================================
   RUIN.OS — Button click sound (terminal pages)
   Plays the "Button" sound on every button click inside a
   .rt-screen (Account / Market / Play). One delegated listener
   for the whole page; loaded once (guarded).
   To change the sound: swap CLICK_SOUND_URL below.
   ============================================================ */
(function () {
  if (window.__ruinosSound) return;   // load once even if included by several sections
  window.__ruinosSound = true;

  var CLICK_SOUND_URL = ''; /* retired 2026-10-11 (old Button.wav on every rt button) — paste a URL to re-arm */
  if (!CLICK_SOUND_URL) return;

  // Buttons + our button-styled links, but only within the terminal UI.
  var SELECTOR = '.rt-screen button, ' +
    '.rt-screen a.rt-btn, .rt-screen a.rt-play-btn, .rt-screen a.rt-share-btn, ' +
    '.rt-screen a.rt-game-btn, .rt-screen a.rt-pool-btn, .rt-screen a.rt-foot-link';

  document.addEventListener('click', function (e) {
    var el = e.target.closest(SELECTOR);
    if (!el || el.disabled) return;
    try {
      var a = new Audio(CLICK_SOUND_URL);
      a.volume = 0.5;
      a.play().catch(function () {});
    } catch (err) {}
  }, true);
})();
